export default "__VITE_ASSET__Bh$BEl$P__"